import { Reservation, ReservationStatus, ReservationType } from '@/types/residents/reservation';
import dayjs from 'dayjs';

export const reservations: Reservation[] = [
  {
    id: 'RES001',
    amenity: {
      id: 'FAC001',
      name: 'Clubhouse Hall'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES001',
      name: 'John Doe'
    },
    startTime: new Date('2024-03-20T18:00:00'),
    endTime: new Date('2024-03-20T20:00:00'),
    attendees: 20,
    purpose: 'Birthday party for my son',
    notes: 'Will need tables and chairs setup'
  },
  {
    id: 'RES002',
    amenity: {
      id: 'FAC002',
      name: 'Swimming Pool'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES002',
      name: 'Jane Smith'
    },
    startTime: new Date('2024-03-22T10:00:00'),
    endTime: new Date('2024-03-22T11:00:00'),
    attendees: 1,
    purpose: 'Morning swim'
  },
  {
    id: 'RES003',
    amenity: {
      id: 'FAC003',
      name: 'Tennis Court 1'
    },
    type: 'personal' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES003',
      name: 'Mike Johnson'
    },
    startTime: new Date('2024-03-25T16:00:00'),
    endTime: new Date('2024-03-25T17:30:00'),
    attendees: 2,
    purpose: 'Tennis practice'
  },
  {
    id: 'RES004',
    amenity: {
      id: 'FAC004',
      name: 'Gym'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES004',
      name: 'Emily Davis'
    },
    startTime: new Date('2024-03-21T07:00:00'),
    endTime: new Date('2024-03-21T08:00:00'),
    attendees: 1,
    purpose: 'Morning workout'
  },
  {
    id: 'RES005',
    amenity: {
      id: 'FAC005',
      name: 'BBQ Area'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES005',
      name: 'David Wilson'
    },
    startTime: new Date('2024-03-23T17:00:00'),
    endTime: new Date('2024-03-23T21:00:00'),
    attendees: 15,
    purpose: 'Community BBQ event'
  },
  {
    id: 'RES006',
    amenity: {
      id: 'FAC006',
      name: 'Conference Room'
    },
    type: 'commercial' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES006',
      name: 'Lisa Brown'
    },
    startTime: new Date('2024-03-24T09:00:00'),
    endTime: new Date('2024-03-24T11:00:00'),
    attendees: 8,
    purpose: 'Business meeting'
  },
  {
    id: 'RES007',
    amenity: {
      id: 'FAC007',
      name: 'Playground'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES007',
      name: 'Sarah Miller'
    },
    startTime: new Date('2024-03-26T15:00:00'),
    endTime: new Date('2024-03-26T17:00:00'),
    attendees: 5,
    purpose: 'Children playdate'
  },
  {
    id: 'RES008',
    amenity: {
      id: 'FAC008',
      name: 'Garden Area'
    },
    type: 'personal' as ReservationType,
    status: 'rejected' as ReservationStatus,
    resident: {
      id: 'RES008',
      name: 'Robert Taylor'
    },
    startTime: new Date('2024-03-27T10:00:00'),
    endTime: new Date('2024-03-27T12:00:00'),
    attendees: 3,
    purpose: 'Gardening workshop'
  },
  {
    id: 'RES009',
    amenity: {
      id: 'FAC009',
      name: 'Basketball Court'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES009',
      name: 'Michael Anderson'
    },
    startTime: new Date('2024-03-28T18:00:00'),
    endTime: new Date('2024-03-28T20:00:00'),
    attendees: 10,
    purpose: 'Basketball tournament'
  },
  {
    id: 'RES010',
    amenity: {
      id: 'FAC010',
      name: 'Library'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES010',
      name: 'Jennifer Garcia'
    },
    startTime: new Date('2024-03-29T14:00:00'),
    endTime: new Date('2024-03-29T16:00:00'),
    attendees: 2,
    purpose: 'Study session'
  },
  {
    id: 'RES011',
    amenity: {
      id: 'FAC011',
      name: 'Spa Center'
    },
    type: 'commercial' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES011',
      name: 'Amanda Martinez'
    },
    startTime: new Date('2024-03-30T11:00:00'),
    endTime: new Date('2024-03-30T13:00:00'),
    attendees: 1,
    purpose: 'Spa treatment'
  },
  {
    id: 'RES012',
    amenity: {
      id: 'FAC012',
      name: 'Movie Theater'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES012',
      name: 'Christopher Lee'
    },
    startTime: new Date('2024-04-01T19:00:00'),
    endTime: new Date('2024-04-01T22:00:00'),
    attendees: 25,
    purpose: 'Movie night'
  },
  {
    id: 'RES013',
    amenity: {
      id: 'FAC013',
      name: 'Yoga Studio'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES013',
      name: 'Nicole Rodriguez'
    },
    startTime: new Date('2024-04-02T08:00:00'),
    endTime: new Date('2024-04-02T09:00:00'),
    attendees: 1,
    purpose: 'Morning yoga'
  },
  {
    id: 'RES014',
    amenity: {
      id: 'FAC014',
      name: 'Party Hall'
    },
    type: 'personal' as ReservationType,
    status: 'cancelled' as ReservationStatus,
    resident: {
      id: 'RES014',
      name: 'Kevin White'
    },
    startTime: new Date('2024-04-03T18:00:00'),
    endTime: new Date('2024-04-03T23:00:00'),
    attendees: 30,
    purpose: 'Anniversary celebration'
  },
  {
    id: 'RES015',
    amenity: {
      id: 'FAC015',
      name: 'Fitness Center'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES015',
      name: 'Stephanie Clark'
    },
    startTime: new Date('2024-04-04T06:00:00'),
    endTime: new Date('2024-04-04T07:00:00'),
    attendees: 1,
    purpose: 'Early morning workout'
  },
  {
    id: 'RES016',
    amenity: {
      id: 'FAC016',
      name: 'Outdoor Amphitheater'
    },
    type: 'community' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES016',
      name: 'Daniel Lewis'
    },
    startTime: new Date('2024-04-05T20:00:00'),
    endTime: new Date('2024-04-05T22:00:00'),
    attendees: 50,
    purpose: 'Summer concert'
  },
  {
    id: 'RES017',
    amenity: {
      id: 'FAC017',
      name: 'Indoor Pool'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES017',
      name: 'Rachel Hall'
    },
    startTime: new Date('2024-04-06T16:00:00'),
    endTime: new Date('2024-04-06T17:00:00'),
    attendees: 1,
    purpose: 'Swimming lesson'
  },
  {
    id: 'RES018',
    amenity: {
      id: 'FAC018',
      name: 'Business Center'
    },
    type: 'commercial' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES018',
      name: 'Thomas Young'
    },
    startTime: new Date('2024-04-07T10:00:00'),
    endTime: new Date('2024-04-07T12:00:00'),
    attendees: 4,
    purpose: 'Client presentation'
  },
  {
    id: 'RES019',
    amenity: {
      id: 'FAC019',
      name: 'Children\'s Play Area'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES019',
      name: 'Michelle King'
    },
    startTime: new Date('2024-04-08T14:00:00'),
    endTime: new Date('2024-04-08T16:00:00'),
    attendees: 8,
    purpose: 'Birthday party'
  },
  {
    id: 'RES020',
    amenity: {
      id: 'FAC020',
      name: 'Meditation Room'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES020',
      name: 'James Scott'
    },
    startTime: new Date('2024-04-09T07:00:00'),
    endTime: new Date('2024-04-09T08:00:00'),
    attendees: 1,
    purpose: 'Morning meditation'
  },
  {
    id: 'RES021',
    amenity: {
      id: 'FAC021',
      name: 'Game Room'
    },
    type: 'community' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES021',
      name: 'Ashley Green'
    },
    startTime: new Date('2024-04-10T19:00:00'),
    endTime: new Date('2024-04-10T21:00:00'),
    attendees: 6,
    purpose: 'Game night'
  },
  {
    id: 'RES022',
    amenity: {
      id: 'FAC022',
      name: 'Art Studio'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES022',
      name: 'Brandon Baker'
    },
    startTime: new Date('2024-04-11T15:00:00'),
    endTime: new Date('2024-04-11T17:00:00'),
    attendees: 3,
    purpose: 'Art workshop'
  },
  {
    id: 'RES023',
    amenity: {
      id: 'FAC023',
      name: 'Music Room'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES023',
      name: 'Lauren Adams'
    },
    startTime: new Date('2024-04-12T18:00:00'),
    endTime: new Date('2024-04-12T19:00:00'),
    attendees: 1,
    purpose: 'Piano practice'
  },
  {
    id: 'RES024',
    amenity: {
      id: 'FAC024',
      name: 'Cooking Class Kitchen'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES024',
      name: 'Ryan Nelson'
    },
    startTime: new Date('2024-04-13T14:00:00'),
    endTime: new Date('2024-04-13T16:00:00'),
    attendees: 12,
    purpose: 'Cooking class'
  },
  {
    id: 'RES025',
    amenity: {
      id: 'FAC025',
      name: 'Pet Park'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES025',
      name: 'Samantha Carter'
    },
    startTime: new Date('2024-04-14T09:00:00'),
    endTime: new Date('2024-04-14T10:00:00'),
    attendees: 2,
    purpose: 'Dog training'
  },
  {
    id: 'RES026',
    amenity: {
      id: 'FAC026',
      name: 'Rooftop Terrace'
    },
    type: 'personal' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES026',
      name: 'Justin Mitchell'
    },
    startTime: new Date('2024-04-15T20:00:00'),
    endTime: new Date('2024-04-15T22:00:00'),
    attendees: 4,
    purpose: 'Sunset dinner'
  },
  {
    id: 'RES027',
    amenity: {
      id: 'FAC027',
      name: 'Indoor Tennis Court'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES027',
      name: 'Melissa Perez'
    },
    startTime: new Date('2024-04-16T17:00:00'),
    endTime: new Date('2024-04-16T18:30:00'),
    attendees: 2,
    purpose: 'Tennis match'
  },
  {
    id: 'RES028',
    amenity: {
      id: 'FAC028',
      name: 'Wine Cellar'
    },
    type: 'commercial' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES028',
      name: 'Gregory Roberts'
    },
    startTime: new Date('2024-04-17T19:00:00'),
    endTime: new Date('2024-04-17T21:00:00'),
    attendees: 6,
    purpose: 'Wine tasting event'
  },
  {
    id: 'RES029',
    amenity: {
      id: 'FAC029',
      name: 'Outdoor Cinema'
    },
    type: 'community' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES029',
      name: 'Hannah Turner'
    },
    startTime: new Date('2024-04-18T20:00:00'),
    endTime: new Date('2024-04-18T23:00:00'),
    attendees: 40,
    purpose: 'Movie under the stars'
  },
  {
    id: 'RES030',
    amenity: {
      id: 'FAC030',
      name: 'Squash Court'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES030',
      name: 'Nathan Phillips'
    },
    startTime: new Date('2024-04-19T16:00:00'),
    endTime: new Date('2024-04-19T17:00:00'),
    attendees: 2,
    purpose: 'Squash game'
  },
  {
    id: 'RES031',
    amenity: {
      id: 'FAC031',
      name: 'Indoor Basketball Court'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES031',
      name: 'Victoria Campbell'
    },
    startTime: new Date('2024-04-20T18:00:00'),
    endTime: new Date('2024-04-20T20:00:00'),
    attendees: 12,
    purpose: 'Basketball league'
  },
  {
    id: 'RES032',
    amenity: {
      id: 'FAC032',
      name: 'Pilates Studio'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES032',
      name: 'Derek Parker'
    },
    startTime: new Date('2024-04-21T08:00:00'),
    endTime: new Date('2024-04-21T09:00:00'),
    attendees: 1,
    purpose: 'Pilates session'
  },
  {
    id: 'RES033',
    amenity: {
      id: 'FAC033',
      name: 'Outdoor Volleyball Court'
    },
    type: 'community' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES033',
      name: 'Olivia Evans'
    },
    startTime: new Date('2024-04-22T17:00:00'),
    endTime: new Date('2024-04-22T19:00:00'),
    attendees: 8,
    purpose: 'Volleyball tournament'
  },
  {
    id: 'RES034',
    amenity: {
      id: 'FAC034',
      name: 'Indoor Cycling Studio'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES034',
      name: 'Tyler Edwards'
    },
    startTime: new Date('2024-04-23T07:00:00'),
    endTime: new Date('2024-04-23T08:00:00'),
    attendees: 1,
    purpose: 'Cycling workout'
  },
  {
    id: 'RES035',
    amenity: {
      id: 'FAC035',
      name: 'Outdoor Dining Area'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES035',
      name: 'Zoe Collins'
    },
    startTime: new Date('2024-04-24T19:00:00'),
    endTime: new Date('2024-04-24T21:00:00'),
    attendees: 4,
    purpose: 'Dinner party'
  },
  {
    id: 'RES036',
    amenity: {
      id: 'FAC036',
      name: 'Indoor Rock Climbing'
    },
    type: 'personal' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES036',
      name: 'Ethan Stewart'
    },
    startTime: new Date('2024-04-25T15:00:00'),
    endTime: new Date('2024-04-25T17:00:00'),
    attendees: 2,
    purpose: 'Rock climbing session'
  },
  {
    id: 'RES037',
    amenity: {
      id: 'FAC037',
      name: 'Outdoor Yoga Deck'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES037',
      name: 'Ava Morris'
    },
    startTime: new Date('2024-04-26T08:00:00'),
    endTime: new Date('2024-04-26T09:00:00'),
    attendees: 15,
    purpose: 'Sunrise yoga'
  },
  {
    id: 'RES038',
    amenity: {
      id: 'FAC038',
      name: 'Indoor Badminton Court'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES038',
      name: 'Liam Rogers'
    },
    startTime: new Date('2024-04-27T16:00:00'),
    endTime: new Date('2024-04-27T17:00:00'),
    attendees: 2,
    purpose: 'Badminton match'
  },
  {
    id: 'RES039',
    amenity: {
      id: 'FAC039',
      name: 'Outdoor Fire Pit'
    },
    type: 'community' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES039',
      name: 'Mia Reed'
    },
    startTime: new Date('2024-04-28T20:00:00'),
    endTime: new Date('2024-04-28T22:00:00'),
    attendees: 10,
    purpose: 'Campfire gathering'
  },
  {
    id: 'RES040',
    amenity: {
      id: 'FAC040',
      name: 'Indoor Golf Simulator'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES040',
      name: 'Noah Cook'
    },
    startTime: new Date('2024-04-29T14:00:00'),
    endTime: new Date('2024-04-29T16:00:00'),
    attendees: 1,
    purpose: 'Golf practice'
  },
  {
    id: 'RES041',
    amenity: {
      id: 'FAC041',
      name: 'Outdoor Soccer Field'
    },
    type: 'community' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES041',
      name: 'Isabella Morgan'
    },
    startTime: new Date('2024-04-30T17:00:00'),
    endTime: new Date('2024-04-30T19:00:00'),
    attendees: 16,
    purpose: 'Soccer match'
  },
  {
    id: 'RES042',
    amenity: {
      id: 'FAC042',
      name: 'Indoor Table Tennis'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES042',
      name: 'Mason Bell'
    },
    startTime: new Date('2024-05-01T18:00:00'),
    endTime: new Date('2024-05-01T19:00:00'),
    attendees: 2,
    purpose: 'Table tennis game'
  },
  {
    id: 'RES043',
    amenity: {
      id: 'FAC043',
      name: 'Outdoor Cricket Ground'
    },
    type: 'community' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES043',
      name: 'Sophia Murphy'
    },
    startTime: new Date('2024-05-02T15:00:00'),
    endTime: new Date('2024-05-02T18:00:00'),
    attendees: 22,
    purpose: 'Cricket match'
  },
  {
    id: 'RES044',
    amenity: {
      id: 'FAC044',
      name: 'Indoor Bowling Alley'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES044',
      name: 'Lucas Bailey'
    },
    startTime: new Date('2024-05-03T19:00:00'),
    endTime: new Date('2024-05-03T21:00:00'),
    attendees: 4,
    purpose: 'Bowling night'
  },
  {
    id: 'RES045',
    amenity: {
      id: 'FAC045',
      name: 'Outdoor Archery Range'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES045',
      name: 'Evelyn Rivera'
    },
    startTime: new Date('2024-05-04T10:00:00'),
    endTime: new Date('2024-05-04T12:00:00'),
    attendees: 1,
    purpose: 'Archery practice'
  },
  {
    id: 'RES046',
    amenity: {
      id: 'FAC046',
      name: 'Indoor Swimming Pool'
    },
    type: 'community' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES046',
      name: 'Oliver Cooper'
    },
    startTime: new Date('2024-05-05T16:00:00'),
    endTime: new Date('2024-05-05T18:00:00'),
    attendees: 20,
    purpose: 'Swimming competition'
  },
  {
    id: 'RES047',
    amenity: {
      id: 'FAC047',
      name: 'Outdoor Tennis Court 2'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES047',
      name: 'Harper Richardson'
    },
    startTime: new Date('2024-05-06T17:00:00'),
    endTime: new Date('2024-05-06T18:30:00'),
    attendees: 2,
    purpose: 'Tennis doubles'
  },
  {
    id: 'RES048',
    amenity: {
      id: 'FAC048',
      name: 'Indoor Dance Studio'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES048',
      name: 'Aiden Cox'
    },
    startTime: new Date('2024-05-07T19:00:00'),
    endTime: new Date('2024-05-07T20:00:00'),
    attendees: 1,
    purpose: 'Dance practice'
  },
  {
    id: 'RES049',
    amenity: {
      id: 'FAC049',
      name: 'Outdoor Running Track'
    },
    type: 'community' as ReservationType,
    status: 'pending' as ReservationStatus,
    resident: {
      id: 'RES049',
      name: 'Scarlett Ward'
    },
    startTime: new Date('2024-05-08T06:00:00'),
    endTime: new Date('2024-05-08T08:00:00'),
    attendees: 25,
    purpose: 'Running club'
  },
  {
    id: 'RES050',
    amenity: {
      id: 'FAC050',
      name: 'Indoor Boxing Ring'
    },
    type: 'personal' as ReservationType,
    status: 'approved' as ReservationStatus,
    resident: {
      id: 'RES050',
      name: 'Sebastian Torres'
    },
    startTime: new Date('2024-05-09T20:00:00'),
    endTime: new Date('2024-05-09T21:00:00'),
    attendees: 1,
    purpose: 'Boxing training'
  }
];

export const reservationResponses = [
  {
    ...reservations[0],
    approval: {
      approvedBy: 'ADM001',
      approvedAt: dayjs('2024-03-15T11:00:00').toDate(),
      notes: 'Approved with standard conditions'
    },
    history: [
      {
        id: 'HIS001',
        timestamp: dayjs('2024-03-15T10:00:00').toDate(),
        status: 'pending' as ReservationStatus,
        details: 'Reservation request submitted',
        updatedBy: 'RES001'
      },
      {
        id: 'HIS002',
        timestamp: dayjs('2024-03-15T11:00:00').toDate(),
        status: 'approved' as ReservationStatus,
        details: 'Reservation approved by admin',
        updatedBy: 'ADM001'
      }
    ]
  }
]; 